module.exports = __webpack_public_path__ + "static/media/share-bg-gradient-one.374859b9.svg";